import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NgbDropdownModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { map } from 'rxjs';
import { APP_CONFIGURATION_TOKEN } from '../../core';
import { UserService } from '../../services';
import { BaseComponent, HelpComponent, LanguageSelectionComponent } from '../../shared';


/**
 * Horizontal bar on top of template.
 */
@Component({
	selector: 'tsp-navbar',
	imports: [
		NgbDropdownModule,
		LanguageSelectionComponent
	],
	templateUrl: './navbar.component.html',
	changeDetection: ChangeDetectionStrategy.Eager
})
export class NavbarComponent extends BaseComponent {

	private readonly modalSrv = inject(NgbModal);
	private readonly userSrv = inject(UserService);
	private readonly configs = inject(APP_CONFIGURATION_TOKEN);

	guideList: any[] = [];
	isPlatformDemo = false;
	eifuSiteUrl = this.configs.eifuSite;
	customerCareEmail = this.configs.customerCareEmail;
	username = toSignal(this.userSrv.getUserName().pipe(map(name => `${name.firstName} ${name.lastName}`)), { initialValue: '' });


	getGuideList(open: boolean): void {
		// TODO
	}

	openHelpModal(): void {
		if (!this.modalSrv.hasOpenModals()) {
			this.modalSrv.open(HelpComponent, { backdropClass: 'wrapper-modal-help', windowClass: 'wrapper-modal-help' });
		}
	}

	openGuide(path: string): void {
		// TODO
	}

}
